var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 26.6673V29.6273C25.3333 30.1796 24.8856 30.6273 24.3333 30.6273H23.6667C23.1144 30.6273 22.6667 30.1796 22.6667 29.6273V26.6673H19.6667C19.1144 26.6673 18.6667 26.2196 18.6667 25.6673V25.0007C18.6667 24.4484 19.1144 24.0007 19.6667 24.0007H22.6667V21.0007C22.6667 20.4484 23.1144 20.0007 23.6667 20.0007H24.3333C24.8856 20.0007 25.3333 20.4484 25.3333 21.0007V24.0007H28.3333C28.8856 24.0007 29.3333 24.4484 29.3333 25.0007V25.6673C29.3333 26.2196 28.8856 26.6673 28.3333 26.6673H25.3333ZM28 14.6673C28 15.6914 27.9029 16.696 27.717 17.6895C27.6686 17.9481 27.3836 18.0817 27.1422 17.9771C26.6238 17.7525 26.0763 17.5838 25.496 17.4711C25.2709 17.4273 25.1184 17.2118 25.1565 16.9857C25.2693 16.3167 25.3333 15.6341 25.3333 14.9607V8.40065L16.4071 4.4221C16.148 4.30661 15.852 4.30661 15.5929 4.4221L6.66667 8.40065V14.9607C6.66667 20.7206 11 26.6673 16 28.0006H16.3709C16.5467 28.0006 16.7016 28.1156 16.7533 28.2835C16.9111 28.7952 17.0605 29.2438 17.3106 29.6839C17.4479 29.9256 17.3456 30.2482 17.0802 30.3309L16.265 30.5848C16.0916 30.6388 15.9063 30.6453 15.7308 30.5987C8.98685 28.8061 4 21.9705 4 14.6673V7.31719C4 6.922 4.23273 6.56388 4.59386 6.40338L15.5939 1.51449C15.8524 1.39957 16.1476 1.39957 16.4061 1.51449L27.4061 6.40338C27.7673 6.56388 28 6.922 28 7.31719V14.6673Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.0007L14.6667 18.6673L20 13.334",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.6eeffe68007b0191763642e69318f897.svg";
export { ForwardRef as ReactComponent };